import { useEffect, useState } from "react"
import CommandCenterService from "../../../service/CommandCenterService";
import useUrlParams from "./useUrlParams";
import useTrueTwin from "./useTrueTwin";
import useScenario from "./useScenario";
import { isOperateMode } from "./utils";

const useDownloadFile = () => {
    const [downloadFiles, setDownloadFiles] = useState([])
    const { truetwin_id } = useTrueTwin()
    const { dashboard } = useUrlParams()
    const { scenario } = useScenario()
    const operateMode = isOperateMode(dashboard, scenario)

    const get_truetwin_datastore_files = () => {
        CommandCenterService.getTrueTwinDataStoreFiles(truetwin_id)?.then((res) => {
            if (res?.data && res?.data?.length > 0) {
                const sortedArray = res.data.slice().sort((a, b) => b?.time - a?.time);
                setDownloadFiles(sortedArray)
            } else {
                setDownloadFiles([])
            }
        }).catch((err) => {
            console.error(err);
        });
    }
    
    useEffect(() => {
        // This API is only used for 'QUICK_DEPLOY', 'HARDWARE_IN_LOOP' download section which is hidden in operate mode
        if (truetwin_id && scenario?.scenarioDeploymentType && ['QUICK_DEPLOY', 'HARDWARE_IN_LOOP'].includes(scenario?.scenarioDeploymentType)) {
            const Interval = setInterval(() => {
                get_truetwin_datastore_files()
                if (dashboard === 'summary') {
                    clearInterval(Interval)
                }
            }, 10000)
            return () => clearInterval(Interval);
        } else {
            // Clear files when switching to operate mode
            setDownloadFiles([])
        }
    }, [truetwin_id, scenario?.scenarioDeploymentType, dashboard])

    return {
        downloadFiles
    }
}

export default useDownloadFile